<template>
  <div class="incompleted-confirm">
    <div class="title">불완전 결제 처리</div>

    <div v-if="productList.length === 0" class="null">
      <div class="null-txt">
        <p>결제 내역이 없습니다.</p>
      </div>
    </div>

    <div v-else class="incompleted-confirm-table">
      <table>
        <tr class="header">
          <th>결제 상품</th>
          <th>개수</th>
          <th>결제 금액</th>
        </tr>

        <tr v-for="item in productList" :key="item.ID">
          <td>
            {{ item.productName }}
          </td>
          <td>
            {{ item.count }}
          </td>
          <td class="price">
            {{ (item.salePrice * item.count).toLocaleString() }}원
          </td>
        </tr>
      </table>
    </div>

    <div class="total">
      <div>총합계 {{ totalPrice.toLocaleString() }}원</div>
      <div class="sub">*위의 결제 정보로 처리합니다.</div>
    </div>

    <div class="ctrl">
      <button class="btn unpurchased" :disabled="loading" @click="unpurchased">
        <img src="/static/img/ico-credit-card-remove-outline.png" alt />
        미결제 처리
      </button>
      <button v-if="tab === 'incompleted'" class="btn pending" :disabled="loading" @click="pending">
        <img src="/static/img/ico-progress-question.png" alt />
        보류 처리
      </button>
      <button v-else class="btn pending" :disabled="loading" @click="discard">
        <img src="/static/img/ico-delete-forever.png" alt />
        영구 보류 처리
      </button>
      <button
        class="btn confirm"
        :disabled="productList.length === 0 || loading"
        @click="confirm"
      >
        <img src="/static/img/ico-check-bold.png" alt />
        결제 처리
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';

export default {
  props: ['tab', 'incompleted', 'uID'],
  data: () => ({
    productList: [],
    totalPrice: 0,
    loading: false,
  }),
  watch: {
    incompleted: {
      handler() {
        this.extractProducts();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    extractProducts() {
      this.productList = [];
      this.totalPrice = 0;
      if (!this.incompleted || !this.incompleted.products) {
        return;
      }

      const productList = [];
      let totalPrice = 0;
      const types = Object.keys(this.incompleted.products);
      for (let i = 0; i < types.length; i++) {
        const type = this.incompleted.products[types[i]];
        for (let j = 0; j < type.length; j++) {
          const product = type[j];
          if (product.count !== 0) {
            productList.push(product);
            totalPrice += product.salePrice * product.count;
          }
        }
      }
      this.productList = productList;
      this.totalPrice = totalPrice;
    },
    async unpurchased() {
      this.loading = true;

      try {
        const res = await this.$http.put(
          `${Configuration.value('CPAYMENT_ADDRESS')}/api/v1/cpayment/payment/${
            this.incompleted.ID
          }/unpurchased`,
          {
            deviceID: this.incompleted.deviceID,
            OperatorUID: this.uID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.$emit('refresh');
        this.loading = false;
      } catch (e) {
        this.loading = false;

        alert('미결제 처리 하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async pending() {
      this.loading = true;

      try {
        const res = await this.$http.put(
          `${Configuration.value('CPAYMENT_ADDRESS')}/api/v1/cpayment/payment/${
            this.incompleted.ID
          }/pending`,
          {
            deviceID: this.incompleted.deviceID,
            OperatorUID: this.uID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.$emit('refresh');
        this.loading = false;
      } catch (e) {
        this.loading = false;

        alert('보류 처리 하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async discard() {
      this.loading = true;

      try {
        const res = await this.$http.put(
          `${Configuration.value('CPAYMENT_ADDRESS')}/api/v1/cpayment/payment/${
            this.incompleted.ID
          }/discard`,
          {
            deviceID: this.incompleted.deviceID,
            OperatorUID: this.uID,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.$emit('refresh');
        this.loading = false;
      } catch (e) {
        this.loading = false;

        alert('영구 보류 처리 하지 못했습니다.\n잠시후 다시 시도해주세요.');
        console.error(e);
      }
    },
    async confirm() {
      this.loading = true;

      try {
        const paymentDetails = [];
        for (let i = 0; i < this.productList.length; i++) {
          const product = this.productList[i];
          const detail = {
            productID: product.productID,
            productName: product.productName,
            productType: product.productType,
            productCount: product.count,
            supplyPrice: product.supplyPrice,
            salePrice: product.salePrice,
            deviceID: product.deviceID,
            trayID: product.trayID,
          };
          paymentDetails.push(detail);
        }
        if (paymentDetails.length === 0) {
          alert('결제 정보가 없습니다.');
          return;
        }

        const res = await this.$http.put(
          `${Configuration.value('CPAYMENT_ADDRESS')}/api/v1/cpayment/payment/${
            this.incompleted.ID
          }`,
          {
            deviceID: this.incompleted.deviceID,
            OperatorUID: this.uID,
            paymentPrice: parseInt(this.totalPrice, 10),
            paymentDetails,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (res.status !== 200) {
          throw new Error(`Response status is "${res.status}"`);
        }
        if (res.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${res.data.resultCode}"`);
        }

        this.$emit('refresh');
        this.loading = false;
      } catch (e) {
        this.loading = false;
        if (e.response.status === 404) {
          alert('할당된 결제가 초기화 되었습니다.\n새로고침 후 다시 시도해주세요.');
        } else if (e.response.status === 405) {
          alert('같은 계정으로 다른 결제를 처리중입니다.\n(계정마다 동시에 처리할 수 있는 결제는 한개로 제한됩니다.)');
        } else {
          alert('결제 처리 하지 못했습니다.\n새로고침 후 다시 시도해주세요.');
        }
        console.error(e);
      }
    },
  },
};
</script>

<style scoped>
.incompleted-confirm table {
  margin-top: 48px;
  width: 100%;
  text-align: center;
  table-layout: fixed;
  border-collapse: collapse;
}
.incompleted-confirm table tr {
  height: 75px;
  font-size: 12px;
  font-weight: bold;
  color: #586063;
  border-bottom: solid 1px #dee0e3;
}
.incompleted-confirm table tr.header {
  background-color: #ffffff;
  color: #b0bec5;
}
.incompleted-confirm table th {
  border-right: solid 1px #dee0e3;
}
.incompleted-confirm table td.price {
  color: #0058ee;
}
.incompleted-confirm .null {
  width: 100%;
  height: 75px;
  background-color: #ffffff;
}
.incompleted-confirm .null-txt {
  margin: auto;
  margin-top: 6px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -0.17px;
  line-height: 75px;
}
.incompleted-confirm .total {
  margin-top: 24px;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #586063;
}
.incompleted-confirm .sub {
  font-size: 14.8px;
  font-weight: normal;
}
.incompleted-confirm .ctrl {
  padding: 45px 0;
  width: 100%;
  text-align: center;
}
.incompleted-confirm .btn {
  width: 352px;
  height: 56px;
  font-size: 12.8px;
  font-weight: bold;
  border-radius: 2px;
  cursor: pointer;
  transition: 0.2s;
}
.incompleted-confirm .btn:disabled {
  background-color: #dedede !important;
  color: #ffffff !important;
  border: solid 1px #dedede !important;
  cursor: default;
}
.incompleted-confirm .btn:not(:last-of-type) {
  margin-right: 16px;
}
.incompleted-confirm .btn img {
  margin-right: 8px;
  width: 24px;
  height: 24px;
  vertical-align: -8px;
}
.incompleted-confirm .btn.unpurchased {
  border: solid 1px #d01156;
  color: #d01156;
}
.incompleted-confirm .btn.unpurchased:hover {
  background-color: rgba(208, 17, 86, 0.1);
}
.incompleted-confirm .btn.pending {
  border: solid 1px #0058ee;
  color: #0058ee;
}
.incompleted-confirm .btn.pending:hover {
  background-color: rgba(0, 88, 238, 0.1);
}
.incompleted-confirm .btn.confirm {
  color: #ffffff;
  background-color: #0058ee;
}
.incompleted-confirm .btn.confirm:hover {
  background-color: #0068fe;
}
.incompleted-confirm .btn.unpurchased img {
  filter: invert(16%) sepia(62%) saturate(6628%) hue-rotate(330deg)
    brightness(84%) contrast(94%);
}
.incompleted-confirm .btn.pending img {
  filter: invert(19%) sepia(83%) saturate(3296%) hue-rotate(214deg)
    brightness(100%) contrast(103%);
}
.incompleted-confirm .btn:not(.confirm):disabled img {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(248deg)
    brightness(106%) contrast(106%) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/incompletedPay/IncompletedConfirm.vue